import { Herolist } from "../heros/Herolist"

export const DcScreen = () => {
  return (
    <div>
        <Herolist publisher="DC Comics"/>
    </div>
  )
}
